import { Button } from "primereact/button";
import React from "react";
import { useState } from "react";
import DatasetSelection from "./DatasetSelection";
import DatasetView from "./DatasetView";
import { Dataset } from "./types";
import { removeItemById } from "./utils";

const DatasetWindow = () => {
  const [selectedDatasets, setSelectedDatasets] = useState<Array<Dataset>>([]);
  const [enableXAxis, setEnableXAxis] = useState<boolean>(true);
  const [togleDatasetsSelectionPanel, setToggleDatasetsSelectionPanel] = useState<boolean>(true);

  const selectDatasets = (datasets: Array<Dataset>) => {
    setSelectedDatasets(datasets);
  };

  const removeDataset = (removedId: string) => {
    const updatedArr = removeItemById(selectedDatasets, removedId);
    setSelectedDatasets(updatedArr);
  };

  return (
    <div className="windowSplit">
      {togleDatasetsSelectionPanel ? (
        <Button
          icon="pi pi-chevron-left"
          className="toggleButton p-button p-button-text"
          onClick={() => setToggleDatasetsSelectionPanel(!togleDatasetsSelectionPanel)}
        />
      ) : (
        <Button
          icon="pi pi-chevron-right"
          className="toggleButton collapsed p-button p-button-text"
          onClick={() => setToggleDatasetsSelectionPanel(!togleDatasetsSelectionPanel)}
        />
      )}
      <div style={{ display: "inline" }}>
        {togleDatasetsSelectionPanel && (
          <div className="datatable  horizontal">
            <DatasetSelection selectDatasets={selectDatasets} updatedDatasets={selectedDatasets} />
          </div>
        )}
      </div>

      <DatasetView selectedDatasetsID={selectedDatasets} removeDataset={removeDataset} />
    </div>
  );
};

export default DatasetWindow;
